import styled from '@emotion/styled'
import React, { useCallback } from 'react'
import Link from 'next/link'
import { logClickEvent } from '../../../firebase/analytics'
import { useLocale } from '../../../hooks/useLocale'
import Image from 'next/image'
import { GameTitle } from '@/clients/models/types/GameTitle'

type Props = {
  game?: GameTitle
}

export const ProfileEditorAppBanner: React.FC<Props> = ({ game }) => {
  const { t } = useLocale()
  const onClickInstallApp = useCallback(() => {
    logClickEvent('ProfileCardDetailInstallBetaClick')
  }, [])

  const getBannerMessage = () => {
    switch (game) {
      case 'valorant':
        return 'みんな使ってるVALORANTフレンド探しアプリ！ランクやプレイスタイルが近い人と遊べるよ🎉'
      case 'overwatch2':
        return 'みんな使ってるOverwatch2フレンド探しアプリ！OW2募集するならGameeアプリ🎉'
      case 'splatoon3':
        return 'みんな使ってるスプラ友達探しアプリ！ウデマエやレートが近い人と遊べるよ🎉'
      case 'apex':
        return 'みんな使ってるApexフレンド探しアプリ！ランクやプレイスタイルが近い人と遊べるよ🎉'
      default:
        return 'みんな使ってるゲーム友達探しアプリ！ランクやプレイスタイルが近い人と遊べるよ🎉'
    }
  }

  return (
    <Link
      href={'https://gameegames.page.link/dA3L'}
      style={{
        textDecoration: 'none',
      }}
      target={'_blank'}
      onClick={onClickInstallApp}
    >
      <Container data-no-ads="true">
        <AppImage>
          <Image
            src="/static/images/icn_app_icon.png"
            alt="gameeロゴ"
            width={28}
            height={28}
            unoptimized={true}
          />
        </AppImage>
        <MessageContainer>
          <MessageText>{getBannerMessage()}</MessageText>
        </MessageContainer>
        <ButtonContainer>
          <InstallButton>{t.ProfileEditorAppBannerButton}</InstallButton>
        </ButtonContainer>
      </Container>
    </Link>
  )
}

const Container = styled.div`
  margin-top: 4px;
  margin-left: 4px;
  margin-right: 4px;

  display: flex;
  border-radius: 8px;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: linear-gradient(90deg, #54c8e3 0%, #8b6bfc 100%);
  left: 0;
  box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
`

const AppImage = styled.div`
  height: 28px;
  width: 28px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
`

const MessageContainer = styled.div`
  flex: 1;
  padding: 0 10px;
`

const MessageText = styled.div`
  font-size: 11px;
  font-weight: bold;
  color: white;
  display: flex;
  align-items: center;
  line-height: 1.4;
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.1);
`

const ButtonContainer = styled.div`
  flex-shrink: 0;
`

const InstallButton = styled.div`
  padding: 6px 10px;
  font-size: 11px;
  font-weight: bold;
  border-radius: 4px;
  overflow: hidden;
  color: #8b6bfc;
  background: white;
  display: flex;
  align-items: center;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
`
